<template>
  <div class="animated fadeIn">
    <CRow>
      <CCol lg="12">
        <CCard class="p-3">
          <CCardHeader>
            <CCardTitle> <i class="cil-library mr-3"></i>Analyze </CCardTitle>
            <CRow class="pt-2">
              <CCol md="4" class="pb-2">
                <!-- <CSelect :options="searchDropdownPartner_id" v-on:change="onChange" /> -->
                <multiselect
                  v-model="selectedPartnerId"
                  placeholder="Seleccione un Partner"
                  label="value"
                  track-by="id"
                  :options="partners"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :multiple="false"
                  :taggable="false"
                ></multiselect>
                <!-- @input="onChangePartnerId()" -->
                <!-- <multiselect
                  v-model="selectedPartnerId"
                  placeholder="Seleccione un Partner"
                  :options="searchDropdownPartner_id"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :multiple="false"
                  :taggable="true"
                  
                  @input="onChangePartnerId()"
                ></multiselect> -->
              </CCol>
              <CCol md="4" class="pb-2">
                <!-- <CSelect :options="searchDropdownName" /> -->
                <multiselect
                  v-model="selectedName"
                  placeholder="Seleccione un Survey"
                  label="qul_name"
                  track-by="id"
                  :options="surveys_temp"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :multiple="false"
                  :taggable="false"
                  @input="onChangeName()"
                ></multiselect>
              </CCol>
              <!-- <CCol md="4" class="pb-2">
                <date-picker
                    v-model="range"
                    range
                    :shortcuts="shortcuts"
                    confirm
                    @change="onChangeDateSearch(range)"
                  ></date-picker>
                
              </CCol> -->
            </CRow>
          </CCardHeader>

          <div class="text-center p-5 row" v-if="isLoading_quiz">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="#63c2de"
              class="offset-6"
              >Entrar</semipolar-spinner
            >
          </div>
          <div v-else>
            <CRow class="mt-3">
              <CCol
                lg="3"
                class="partner-card"
                v-for="item in pageOfItems"
                :key="item.id"
              >
                <CCard class="shadow mb-5 bg-grey rounded">
                  <router-link :to="'/answer/' + item.id">
                    <!-- <CCardBody color="light" align="center" class="box"> -->
                    <CCardBody class="box p-0" backgroupcolor="light">
                      <!-- :style="{
                      backgroundImage: `url(${getimage(item.id)})`
                   }" -->
                      <CImg
                        style="width: 80%"
                        :src="getimage(item.title_img[0])"
                        class="p-0"
                      />
                    </CCardBody>
                    <!-- <CCardBody class="box fill-height bg-image" backgroupcolor="light" 
                  :style="{
                      backgroundImage: `url(${item.title_img.image_url})`
                   }" /> -->
                  </router-link>
                  <span class="text-center p-3 pb-0">
                    <router-link :to="'/answer/' + item.id">
                      <strong>{{ item.display_name }}</strong>
                    </router-link></span
                  >
                  <span class="text-center pt-0 pb-3">
                    <router-link :to="'/answer/' + item.id">
                      <strong>{{ item.slug2 }}</strong>
                    </router-link></span
                  >
                  <CCardFooter align="center" class="p-3">
                    <!-- <CCardText>{{item.stat_ids.length}} Respuestas</CCardText> -->
                    <CCardText>{{ getcomments(item.id) }} Respuestas</CCardText>
                  </CCardFooter>
                </CCard>
              </CCol>
            </CRow>
          </div>
          <div class="card-footer pb-0 pt-3">
            <jw-pagination
              :items="surveys"
              @changePage="onChangePageitem"
              :labels="customLabels"
              :pageSize="12"
            ></jw-pagination>
          </div>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import { shuffleArray } from "@/shared/utils";
import store from "../../../store";
import { SemipolarSpinner } from "epic-spinners";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";

import moment from "moment";

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};

export default {
  name: "tables",
  components: {
    SemipolarSpinner,
    Multiselect,
    DatePicker,
    // DateRangePicker,
  },

  data: () => {
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    var last7days = new Date(today);
    last7days.setDate(last7days.getDate() - 6);
    var lastmonth = new Date(today);
    lastmonth.setMonth(lastmonth.getMonth() - 1);
    return {
      date: "",
      time: "",
      range: "",
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.range = [today, today];
          },
        },
        {
          text: "YesterDay",
          onClick: () => {
            this.range = [yesterday, yesterday];
          },
        },
        {
          text: "Last 7 Days",
          onClick: () => {
            this.range = [last7days, last7days];
          },
        },
        {
          text: "Last Month",
          onClick: () => {
            this.range = [lastmonth, lastmonth];
          },
        },
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:30",
        end: "23:30",
      },
      customLabels,
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "domain_id", label: "Dominio web", sortable: true },
        { key: "slug2", label: "Slug", sortable: true },
        { key: "link", label: "Link", sortable: true },
        { key: "acciones", label: "Acciones" },
      ],
      isLoading: false,
      isLoading_quiz: false,
      searchDropdownName: [],
      searchDropdownPartner_id: [],
      searchDropdownDate: [],
      pageOfItems: [],
      temp_Quiz: [],
      itemQuizPartner: [],
      itemQuizslug: [],
      partners: [],
      selectedPartnerId: [],
      selectedSurveys: [],
      selectedName: "",
      selectedDate: "",
      surveys: [],
      surveys_temp: [],
      partner_ids: [],
      quiz_ids: [],
      imagesByQuiz: [],
      graphdatabyQuiz: [],
    };
  },
  async mounted() {
    // this.getQuizes();
    var respuesta = await this.getPartners();
    var respuesta = await this.getcommenzadosCount();
  },
  methods: {
    onChangePartnerId() {
      // var disp = this.selectedPartnerId;
      // this.items = this.temp_Quiz;
      // var abc = [];
      // var data = this.items;
      // data.forEach((i) => {
      //   if (i.partner_id.name == disp) {
      //     abc.push(i);
      //   }
      // });
      // this.items = abc;

      var disp = this.selectedPartnerId;
      this.items = this.surveys;
      this.range = "";
      var abc = [];
      var data = this.surveys;
      this.searchDropdownName = [];
      this.selectedName = "";
      if (this.selectedPartnerId == null) {
        this.items = this.temp_Quiz;
        this.itemQuizPartner = [];
      } else {
        data.forEach((i) => {
          if (i.partner_id.name == disp) {
            abc.push(i);
            if (!this.searchDropdownName.includes(i.slug2)) {
              this.searchDropdownName.push(i.slug2);
            }
          }
        });

        this.items = abc;
        this.itemQuizPartner = abc;
      }
    },
    onChangeName() {
      //console.log("this.selectedName", this.selectedName);
      this.selectedSurveys = [];
      // this.selectedSurveys.push(this.selectedName.id);
      if (this.selectedName !== null)
        this.selectedSurveys.push(this.selectedName.id);

      // this.getQuizes();
      this.getQuizesbyQuizid();
    },
    onChangeName12() {
      // var disp = this.selectedName;
      // this.items = this.temp_Quiz;
      // var abc = [];
      // var data = this.items;
      // data.forEach((i) => {
      //   if (i.display_name == disp) {
      //     abc.push(i);
      //   }
      // });
      // this.items = abc;

      var disp = this.selectedName;
      this.range = "";
      // //console.log("this.selectedName ::: ",disp, this.selectedName);
      if (disp == null) {
        this.items = this.itemQuizPartner;
      }
      if (!disp == null || !disp == "") {
        var abc = [];
        var data = this.itemQuizPartner;
        data.forEach((i) => {
          if (i.slug2 == disp) {
            abc.push(i);
          }
        });
        // //console.log("abc :::: ", abc.length);
        this.items = abc;
        this.itemQuizslug = abc;
      }
      if (!this.selectedPartnerId == null) {
        this.items = this.itemQuizPartner;
      }
    },
    onChangeDateSearch() {
      this.getQuizes();
    },
    onChangeDateSearch12() {
      // var disp = this.selectedDate;
      var disp = this.range;
      //console.log(disp);
      // this.items = this.temp_Quiz;
      // var abc = [];
      // var data = this.items;
      // data.forEach((i) => {
      //   if (i.create_date == disp) {
      //     abc.push(i);
      //   }
      // });
      // this.items = abc;
      var quiz_items = [];
      if (this.range[0] == null) {
        quiz_items = this.temp_Quiz;
      }
      if (this.selectedPartnerId !== null || this.selectedPartnerId !== "") {
        // //console.log("this.itemQuizPartner", this.itemQuizPartner, this.selectedPartnerId, this.selectedName);
        quiz_items = this.itemQuizPartner;
        //console.log(quiz_items);
      }
      //console.log( "itemQuizslug , this.selectedName ::::: ", this.selectedName,  this.itemQuizslug  );
      if (this.selectedName !== null || this.selectedName !== "") {
        quiz_items = this.itemQuizslug;
      }
      var start = this.range[0];
      var end = this.range[1];
      if (quiz_items.length > 0) {
        //console.log("before items :::::::: ", quiz_items.length);
        if (start !== null || end !== null) {
          var filtered_data_quiz = quiz_items.filter((item) => {
            return (
              moment(item.create_date) >= moment(start) &&
              moment(item.create_date) <= moment(end)
            );
          });
          this.items = filtered_data_quiz;
          //console.log( "after filter this.items.length :::::::: ",filtered_data_quiz.length  );
        } else {
          // this.items = this.temp_Quiz;
          if (
            this.selectedPartnerId !== null ||
            this.selectedPartnerId !== ""
          ) {
            // //console.log("this.itemQuizPartner", this.itemQuizPartner, this.selectedPartnerId, this.selectedName);
            this.items = this.itemQuizPartner;
            // //console.log(quiz_items);
          }
          // //console.log("itemQuizslug , this.selectedName ::::: ", this.selectedName, this.itemQuizslug);
          if (this.selectedName !== null || this.selectedName !== "") {
            this.items = this.itemQuizslug;
          }
        }
      }
    },
    onChangePageitem(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getPartnersQuiz").then(() => {
          partners = store.getters.getPartnersQuiz;
          this.partners = partners;
          this.partnersArray = partners;

          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;

        ////console.log("partners ::::::::: ",partners);
        return;
      }
      this.isLoading = false;
    },

    async getQuizes() {
      // var location_ids = this.locationSelected;
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      surveys = this.selectedSurveys;
      //console.log("this.range ::: ", this.range);
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }
      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };
      //console.log("payload in view ::: ", payload);
      this.isLoading_quiz = true;
      var quiz_ids = [];
      var image_ids = [];
      await store.dispatch("getQuizes", payload).then(() => {
        var quizes_data = store.getters.getQuizes;
        //console.log("quizes_data::: ", quizes_data);
        var count = 0;
        quizes_data.forEach((data) => {
          quiz_ids.push(data.id);
          image_ids.push(data.title_img[0]);
        });
        //console.log(quiz_ids);
        this.quiz_ids = quiz_ids;
        // this.getImagebyQuiz(quiz_ids);
        if (quizes_data.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          // this.getreview_CountMonth(avgstarratingpermonth_location);
          this.surveys = quizes_data;

          var surveys = quizes_data;

          surveys.forEach((item) => {
            item["qul_name"] = item.name + " - " + item.slug2;
          });
          this.surveys_temp = surveys;

          // this.items = quizes_data;
        } else {
          this.surveys = [];
          this.items = [];
          this.quiz_ids = [];
        }
        this.isLoading_quiz = false;

        return;
      });
      await this.getImagebyQuiz(image_ids);
      await this.getcommenzadosCount();
    },

    async getQuizesbyQuizid() {
      // var location_ids = this.locationSelected;
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      surveys = this.selectedSurveys;
      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };

      //console.log("payload in view ::: ", payload);
      var quiz_ids = [];
      var image_ids = [];

      await store.dispatch("getQuizes", payload).then(() => {
        var quizes_data = store.getters.getQuizes;
        //console.log("quizes_data::: ", quizes_data);
        var count = 0;
        quizes_data.forEach((data) => {
          quiz_ids.push(data.id);
          image_ids.push(data.title_img[0]);
        });
        //console.log("============>", quiz_ids, image_ids);
        this.quiz_ids = quiz_ids;

        if (quizes_data.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          // this.getreview_CountMonth(avgstarratingpermonth_location);
          this.surveys = quizes_data;
          // this.surveys_temp=quizes_data;
          //console.log("this.surveys ::: ", this.surveys, quizes_data.length);
          // this.items = quizes_data;
        } else {
          this.surveys = [];
          this.items = [];
        }
        return;
      });
      await this.getImagebyQuiz(image_ids);
      await this.getcommenzadosCount();
    },

    getQuizes12() {
      var quizes = store.getters.getQuizes;
      if (quizes.length == 0) {
        this.isLoading = true;
        store.dispatch("getQuizes").then(() => {
          quizes = store.getters.getQuizes;
          //console.log("quizes :::::::", quizes.domain_id);
          shuffleArray([quizes]);
          this.isLoading = false;
          this.items = quizes;
          this.temp_Quiz = quizes;
          this.itemsArray = quizes;
          //console.log("items quiz", this.items);

          quizes.forEach((i) => {
            if (!this.searchDropdownName.includes(i.name)) {
              this.searchDropdownName.push(i.name);
            }
            if (i.partner_id != false && i.partner_id.name != undefined) {
              if (!this.searchDropdownPartner_id.includes(i.partner_id.name)) {
                this.searchDropdownPartner_id.push(
                  i.partner_id ? i.partner_id.name : ""
                );
              }
            }

            if (!this.searchDropdownDate.includes(i.create_date)) {
              this.searchDropdownDate.push(i.create_date);
            }
          });
        });
      } else {
        shuffleArray([quizes]);
        this.items = quizes;
        this.temp_Quiz = quizes;
        this.itemsArray = quizes;
        quizes.forEach((i) => {
          if (!this.searchDropdownName.includes(i.name)) {
            this.searchDropdownName.push(i.name);
          }
          if (i.partner_id != false && i.partner_id.name != undefined) {
            if (!this.searchDropdownPartner_id.includes(i.partner_id.name)) {
              this.searchDropdownPartner_id.push(
                i.partner_id ? i.partner_id.name : ""
              );
            }
          }
          if (!this.searchDropdownDate.includes(i.create_date)) {
            this.searchDropdownDate.push(i.create_date);
          }
        });
      }
      //console.log("onChange", this.searchDropdownPartner_id);
    },

    async getcommenzadosCount() {
      var quiz_id = this.$route.params.itemID;
      if (quiz_id !== "") {
        await store.dispatch("getcommenzadosCount", quiz_id).then(() => {
          var commenzadosCount = store.getters.getcommenzadosCount;
          ////console.log("commenzadosCount::: ", commenzadosCount);
          var count = "0";
          ////console.log("count in commenzados", count);
          this.comenzados = commenzadosCount;
          return count;
        });
      }
    },
    async getImagebyQuiz(quiz_ids) {
      // var quiz_id = this.$route.params.itemID;
      //console.log("quiz_ids", quiz_ids);
      var image_url = "";
      if (quiz_ids.length > 0) {
        await store.dispatch("getImagebyQuiz", quiz_ids).then(() => {
          var imagebyQuizData = store.getters.getImagebyQuiz;
          //console.log("imagebyQuizData::: ", imagebyQuizData);
          this.imagesByQuiz = imagebyQuizData;

          // if(imagebyQuizData.length>0){
          //   image_url = imagebyQuizData[0].image_url
          // }
        });
      }
      // return image_url;
    },
    getimage(quiz_id) {
      var image_url = "";
      if (this.imagesByQuiz.length > 0) {
        this.imagesByQuiz.forEach((data) => {
          if (quiz_id === data.id) {
            image_url = data.image_url;
          }
        });
        return image_url;
      }
    },
    getsurveylabel(quiz) {
      var str = "";
      if (quiz !== "" && quiz !== undefined) {
        str = quiz.name + "-" + quiz.slug2;
      }
      //console.log("====>", str);
      return str;
    },
    getcomments(quiz_id) {
      var count = 0;
      this.comenzados.forEach((data) => {
        if (quiz_id == data.quiz_id[0]) {
          count = data.__count;
        }
      });
      //console.log("quiz_id", quiz_id, this.comenzados);
      return count;
    },
  },
  watch: {
    selectedPartnerId: function (partnerSelected) {
      var partner_ids = [];
      this.surveys_temp = [];
      this.selectedSurveys = [];
      this.selectedName = "";
      //console.log("partner_ids::::", partnerSelected);
      if (partnerSelected !== null) {
        partner_ids.push(partnerSelected.id);
      }
      // partnerSelected.forEach((partner) => {
      //     partner_ids.push(partner.id);
      // });
      this.locationSelected = [];
      this.quizSelected = [];

      //console.log("partner_ids::::", partnerSelected, partner_ids);

      if (partner_ids.length > 0) {
        // partner_ids = partner_ids;
        this.partner_ids = partner_ids;
        this.getQuizes();
      } else {
        this.partners = [];
        this.partner_ids = [];
        this.surveys = [];
        this.quiz_ids = [];

        this.surveys_temp = [];
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.headstyle {
  float: right;
}
.box {
  /* height: 175px; */
  /* width: 200px; */
  padding-left: 10px;
  padding-top: 80px;
  padding-bottom: 80px;
  background-image: url(../../../../public/img/Apache_logo.png);
  background-size: cover;
  background-color: "#ced2d8";
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  /* color: blue; */
}

.card-img {
  width: 80%;
}
.partner-card {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
@media screen and (max-width: 767px) {
  .survey-wrapper .col-sm-4 {
    padding-bottom: 10px;
  }
}
@media screen and (max-width: 1100px) {
  .partner-card {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33%;
    flex: 0 0 33%;
    max-width: 33%;
  }
}
@media screen and (max-width: 760px) {
  .partner-card {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media screen and (max-width: 550px) {
  .partner-card {
    width: 100%;
    flex: none;
    max-width: 100%;
  }
  .partner-card img.card-img {
    width: 50%;
  }
}
</style>